import Component from '../app/component'
import ImagesParallax from '../plugins/images-parallax.js'

export default class ProductIntroComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    new ImagesParallax(this.refs.images)
  }
}
